import type { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import SplashScreen from '../../../components/global/SplashScreen'
import ErrorScreen from '../../../components/global/error-screen'
import useAuth from '../useAuth'

export default function AuthGuard({ children }: PropsWithChildren) {
  const { t } = useTranslation()
  const location = useLocation()
  const { isInitializing, userId, isLoading, user } = useAuth()

  if (isInitializing || (userId && isLoading))
    return <SplashScreen>{t('auth.loadingProfile')}</SplashScreen>
  if (!userId)
    return <Navigate to='/login' replace state={{ from: location }} />

  if (!user)
    return (
      <ErrorScreen>
        Could not load your profile, please try refreshing the page.
      </ErrorScreen>
    )

  return <>{children || <Outlet />}</>
}
